/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    /* eslint-disable */
    
    console.log('(z__jpcCleaningUpsell.js) Script starting');
    
    window.PXUTheme.jsJpcCleaningUpsell = {
      init: function($section) {
        console.log('Init function called');
        
        try {
          // Get the section ID
          const sectionId = $section.data('section-id');
          console.log('Section ID:', sectionId);
          
          // Find the section data using the section ID
          const $sectionData = $(`script[data-section-id="${sectionId}"][data-section-data]`);
          console.log('Section data element:', $sectionData);
          
          if ($sectionData.length) {
            const sectionData = JSON.parse($sectionData.html());
            console.log('Parsed section data:', sectionData, sectionData.cleaning_product);
            
            // Extend the object with section data
            window.PXUTheme.jsJpcCleaningUpsell = $.extend(this, sectionData);
            
            console.log('Extended object:', sectionData);
            console.log('Cleaning product:', sectionData.cleaning_product);
            
            this.$section = $section;
            this.$priceSpan = $('#cleaning-upsell-variant-price');
            this.$button = $('#cleaning-upsell-button');
            
            // Check if we have the product data
            if (sectionData.cleaning_product) {
              this.product = sectionData.cleaning_product;
              console.log('Product set for cleaning:', sectionData.cleaning_product);
              
              // Initialize the upsell
              this.initializeCleaningUpsell();
              this.bindEvents();
            } else {
              console.error('No cleaning product data found in section');
            }
          } else {
            console.error('No section data found for section ID:', sectionId);
          }
        } catch (error) {
          console.error('Error in init function:', error);
        }
      },
    
      initializeCleaningUpsell: function() {
        console.log('Initializing cleaning upsell');
        this.updateCleaningUpsell();
      },
    
      bindEvents: function() {
        console.log('Binding events');
        // Handle cleaning add to cart
        this.$button.on('click', (e) => {
          e.preventDefault();
          this.addCleaningToCart();
        });
    
        // Listen for cart updates
        $(document).on('cart:updated', () => {
          this.updateCleaningUpsell();
        });
    
        // Also update when cart drawer is opened/closed
        $(document).on('ajaxCart.afterCartLoad', () => {
          this.updateCleaningUpsell();
        });
    
        // Listen for cart item removal
        $(document).on('click', '.cart__remove-btn', (e) => {
          console.log('Cart item removal detected');
          // Wait for the item to be removed from cart
          setTimeout(() => {
            this.updateCleaningUpsell();
          }, 500); // Small delay to ensure cart is updated
        });
      },
    
      // Function to get cart items count excluding insurance and cleaning products
      getCartItemsCount: function() {
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: (cart) => {
              // Filter out insurance and cleaning products
              const relevantItems = cart.items.filter(item => 
                item.product_type !== "Not a Record"
              );
              
              // Calculate total quantity of relevant items
              const totalQuantity = relevantItems.reduce((sum, item) => sum + item.quantity, 0);

              console.log(cart.items);
              
              // Check if cart only contains non records
              const onlyNonRecords = cart.items.every(item => item.product_type === "Not a Record");
              
              console.log('Cart items count (excluding cleaning and insurance and jukebox strips):', totalQuantity);
              resolve({
                totalQuantity,
                onlyNonRecords
              });
            },
            error: (error) => {
              console.error('Error getting cart items count:', error);
              reject(error);
            }
          });
        });
      },
    
      // Function to check if cleaning is in cart
      checkCleaningInCart: function() {
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json',
            success: (cart) => {
              const cleaningItem = cart.items.find(item => 
                item.product_id === this.product.id
              );
              resolve(cleaningItem);
            },
            error: (error) => {
              console.error('Error checking cleaning in cart:', error);
              reject(error);
            }
          });
        });
      },
    
      // Function to update cleaning quantity in cart
      updateCleaningQuantity: function(quantity) {
        console.log('Updating cleaning quantity to:', quantity);
        return new Promise((resolve, reject) => {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            dataType: 'json',
            contentType: 'application/json',
            data: JSON.stringify({
              updates: {
                [this.product.variants[0].id]: quantity
              }
            }),
            success: (cart) => {
              console.log('Cleaning quantity updated successfully');
              window.location.reload();
            },
            error: (error) => {
              console.error('Error updating cleaning quantity:', error);
              reject(error);
            }
          });
        });
      },
    
      // Function to update cleaning upsell display
      updateCleaningUpsell: async function() {
        console.log('Updating cleaning upsell display');
        try {
          const { totalQuantity, onlyNonRecords } = await this.getCartItemsCount();
          const cleaningItem = await this.checkCleaningInCart();
    
          console.log('(z__jpcCleaningUpsell.js) Items count:', totalQuantity);
          console.log('(z__jpcCleaningUpsell.js)  Cleaning item:', cleaningItem);
          console.log('(z__jpcCleaningUpsell.js)  Only non records:', onlyNonRecords);
    
          // If cart only contains cleaning and/or insurance, remove cleaning
          if (onlyNonRecords && cleaningItem) {
            await this.updateCleaningQuantity(0);
            this.$section.hide();
            console.log('Hiding section - removing cleaning from cart with only cleaning/insurance');
            return;
          }
    
          if (totalQuantity <= 0) {
            this.$section.hide();
            console.log('Hiding section - no items in cart');
            return;
          } else if (cleaningItem && cleaningItem.quantity !== totalQuantity) {
            await this.updateCleaningQuantity(totalQuantity);
            this.$section.hide();
            console.log('Hiding section - updating cleaning quantity', this.$section);
            return;
          } else if (cleaningItem && cleaningItem.quantity === totalQuantity) {
            this.$section.hide();
            console.log('Hiding section - correct cleaning in cart', this.$section);
            return;
          }
    
          // Show section and update price
          this.$section.show();
          this.$priceSpan.text("$" + ((totalQuantity * (this.product.price / 100)).toFixed(2) || ""));
          this.$button.data('variant-id', this.product.variants[0].id);
          this.$button.data('quantity', totalQuantity);
    
          // If cleaning is in cart, update its quantity
          if (cleaningItem && cleaningItem.quantity !== totalQuantity) {
            await this.updateCleaningQuantity(totalQuantity);
          }
        } catch (error) {
          console.error('Error updating cleaning upsell:', error);
        }
      },
    
      // Handle adding cleaning to cart
      addCleaningToCart: function() {
        const variantId = this.$button.data('variant-id');
        const quantity = this.$button.data('quantity');
        console.log('Adding cleaning to cart, variant ID:', variantId, 'quantity:', quantity);
    
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          contentType: 'application/json',
          data: JSON.stringify({
            items: [{
              id: variantId,
              quantity: quantity
            }]
          }),
          success: (response) => {
            console.log('Cleaning added to cart successfully');
            window.location.reload();
          },
          error: (error) => {
            console.error('Error adding cleaning to cart:', error);
            if (error.status === 422) {
              alert('Sorry, this cleaning option is currently not available. Please try again later.');
            } else {
              alert('There was an error adding cleaning to your cart. Please try again.');
            }
          }
        });
      },
    
      unload: function($section) {
        console.log('Unloading section');
        // Clear event listeners
        this.$button.off();
        $(document).off('cart:updated');
        $(document).off('ajaxCart.afterCartLoad');
      }
    };
    
    // Wait for jQuery and theme to be ready
    console.log('Checking for PXUTheme and jQuery');
    console.log('PXUTheme exists:', typeof window.PXUTheme !== 'undefined');
    console.log('jQuery exists:', typeof $ !== 'undefined');
    
    if (typeof window.PXUTheme !== 'undefined' && typeof window.PXUTheme.jsJpcCleaningUpsell !== 'undefined') {
      console.log('Theme and module exist, setting up event listeners');
      
      // Initialize on document ready
      $(document).ready(function() {
        console.log('Document ready');
        const sections = $('[data-section-type="jpC-cart__cleaning-upsell"]');
        console.log('Found sections:', sections.length);
        
        sections.each(function() {
          console.log('Initializing section');
          window.PXUTheme.jsJpcCleaningUpsell.init($(this));
        });
      });
    
      // Initialize on section load (for theme editor)
      $(document).on('shopify:section:load', function(event) {
        console.log('Section load event');
        const $section = $(event.target);
        if ($section.is('[data-section-type="jpC-cart__cleaning-upsell"]')) {
          window.PXUTheme.jsJpcCleaningUpsell.init($section);
        }
      });
    
      // Cleanup on section unload (for theme editor)
      $(document).on('shopify:section:unload', function(event) {
        console.log('Section unload event');
        const $section = $(event.target);
        if ($section.is('[data-section-type="jpC-cart__cleaning-upsell"]')) {
          window.PXUTheme.jsJpcCleaningUpsell.unload($section);
        }
      });
    } else {
      console.log('Theme or module not found');
    }
    
    /******/ })();